import React from "react";
import PropTypes from 'prop-types';
import {Grid, Paper, Typography} from "@material-ui/core";
import CurrencyField from "../Fields/CurrencyField";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";

const LeadPurchaseDecisionInformation = ({decisions}) => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"lead-purchase-decisions"}>Lead Purchase Decisions</Typography>
            {decisions.map (decision => (
                <Paper className={classes.paper}>
                    <Grid container spacing={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Status" value={decision.status || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Decline Reason" value={decision.declineReason}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CurrencyField label="Billable" value={decision.billable}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CurrencyField label="Payable" value={decision.payable}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Is List Manageable" value={decision.isListManageable}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Customer Classification" value={decision.customerClassification}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="New Identity" value={decision.newIdentity}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Returning Customer" value={decision.returningCustomer}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Identity Canonical" value={decision.identityCanonical}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Offer Id" value={decision.offerId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={9}>
                                <TextField label="Redirect Url" value={decision.redirectUrl}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Chance To Sell" value={decision.chanceToSell}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Chance To Sell Elapsed (milliseconds)" value={decision.chanceToSellElapsedInMillis}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Chance To Sell Model Name" value={decision.chanceToSellModelName}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Chance To Sell Prediction" value={decision.chanceToSellModelPrediction}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={1}>
                                <TextField label="Sold Cutoff" value={decision.soldCutoff}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={1}>
                                <TextField label="Sold Cap" value={decision.soldCap}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Arbitrage Method" value={decision.arbitrageMethod}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Market Value" value={decision.marketValue}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Market Value Elapsed (milliseconds)" value={decision.marketValueElapsedInMillis}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Market Value Model Name" value={decision.marketValueModelName}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Market Value Prediction" value={decision.marketValueModelPrediction}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Price Strategy Id" value={decision.priceStrategyId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Price Strategy Name" value={decision.priceStrategyName}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Purchasing Strategy Id" value={decision.purchasingStrategyId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Purchasing Strategy Name" value={decision.purchasingStrategyName}/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Company ID" value={decision.companyId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Adv1" value={decision.adv1}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Adv2" value={decision.adv2}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Adv3" value={decision.adv3}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
        </>
    )
};

LeadPurchaseDecisionInformation.propTypes = {
    decision: PropTypes.shape({
        status: PropTypes.string,
        billable: PropTypes.number,
        payable: PropTypes.number,
        redirectUrl: PropTypes.string,
        declineReason: PropTypes.string,
        customerClassification: PropTypes.string,

        newIdentity: PropTypes.bool,
        returningCustomer: PropTypes.bool,
        identityCanonical: PropTypes.string,

        offerId: PropTypes.string,

        chanceToSell: PropTypes.bool,
        chanceToSellElapsedInMillis: PropTypes.number,
        chanceToSellModelName: PropTypes.string,
        chanceToSellModelPrediction: PropTypes.number,
        soldCutoff: PropTypes.number,
        soldCap: PropTypes.number,
        arbitrageMethod: PropTypes.string,

        marketValue: PropTypes.number,
        marketValueElapsedInMillis: PropTypes.number,
        marketValueModelName: PropTypes.string,
        marketValueModelPrediction: PropTypes.number,
        priceStrategyId: PropTypes.string,
        priceStrategyName: PropTypes.string,
        purchasingStrategyId: PropTypes.string,
        purchasingStrategyName: PropTypes.string,

        isListManageable: PropTypes.bool,

        companyId: PropTypes.string,
        adv1: PropTypes.string,
        adv2: PropTypes.string,
        adv3: PropTypes.string
    }),
};

LeadPurchaseDecisionInformation.defaultProps = {
    decision: {},
};

export default LeadPurchaseDecisionInformation;
